/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type { GetApiProfileCvSummaryQueryResponse } from '../models/GetApiProfileCvSummary.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiProfileCvSummaryQueryResponseSchema } from '../zod/getApiProfileCvSummarySchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiProfileCvSummaryQueryKey = () =>
  [{ url: '/api/profile/cv/summary' }] as const;

export type GetApiProfileCvSummaryQueryKey = ReturnType<
  typeof getApiProfileCvSummaryQueryKey
>;

/**
 * {@link /api/profile/cv/summary}
 */
export async function getApiProfileCvSummary(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProfileCvSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/profile/cv/summary`,
    ...requestConfig,
  });
  return getApiProfileCvSummaryQueryResponseSchema.parse(res.data);
}

export function getApiProfileCvSummaryQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProfileCvSummaryQueryKey();
  return queryOptions<
    GetApiProfileCvSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiProfileCvSummaryQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProfileCvSummary(config);
    },
  });
}

/**
 * {@link /api/profile/cv/summary}
 */
export function useGetApiProfileCvSummary<
  TData = GetApiProfileCvSummaryQueryResponse,
  TQueryData = GetApiProfileCvSummaryQueryResponse,
  TQueryKey extends QueryKey = GetApiProfileCvSummaryQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProfileCvSummaryQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProfileCvSummaryQueryKey();

  const query = useQuery(
    {
      ...getApiProfileCvSummaryQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
